import React from "react";
import './Projects.css'
import { Link } from 'react-router-dom';
import mealvault from '../Images/MEALVAULTLOGO.png'
import thesis from '../Images/BA_Informatik_Alexander_Loewe.pdf'
import thesisImg from '../Images/MySetup.jpeg'
import { Text } from 'react-native';

export function Projects() {
    
    return (
        <>
        <div className="projects">
            <h1> Projects</h1>

            <ProjectItem image={mealvault} subtitle='Mobile-App' title='MealVault' 
            language='Swift'
            description={`With MealVault you can save all your recipes in one place.\nIt is convenient and easy to handle. Stay tuned for future updates.\nDownload it on the Apple App Store.
            `}
            link1={<ProjectItemLink href='/projects/support/MealVault' isPrivacy={false} />}
            link2={<ProjectItemLink href="/projects/privacy/MealVault?startDate=15.04.2025" isPrivacy={true} />}
            />

            <ProjectItem image={thesisImg} subtitle='Bachelor Thesis' title='Event-based vision for a tactile sensor' 
            language='Python'
            description={`Two Machine Learning models were trained to recognize touches on the sensors surface.\n Different event representations and accumulation times were tested.
                `}
            link1={<PDFViewer pdf={thesis} />}
            />
        </div>
        
        </>
    )
}

function ProjectItem({image, subtitle, title, language, description , link1, link2}) {
    
   return (
    <div className="project-item">
    <img src={image} alt={title} className="project-image"/>
    <div className="project-text">
        <small> {subtitle} </small>
        <h3> {title} </h3>
        <Text style={{color: 'white'}}> {description} </Text>
        <div className="project-link">
            <small> Language: {language} </small>
            {link1}
            {link2}
        </div>
    </div>
</div>
   )
}

function ProjectItemLink({href, isPrivacy, ...props}) {
    let text = isPrivacy ? 'Privacy' : 'Support';

    return (
        <Link to={href} {...props}> {text}</Link>
    )
}

function PDFViewer({pdf}) {
    return (
        <a href={pdf} className="pdfLink" target="_blank">PDF</a>
    )
}